import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import request from '@/utils/request'
import permissionDirective from '@/directives/permission'

Vue.use(ElementUI)
Vue.prototype.$API = request
Vue.directive('permission', permissionDirective)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
